import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import ProductInquiryModal from "../../components/User/Common/ProductInquiryModal";

const Cart = () => {
  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    clearCart,
    getTotalItems,
  } = useCart();
  const [showCheckout, setShowCheckout] = useState(false);

  if (cartItems.length === 0) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
        <ShoppingBag size={64} className="text-gray-300 mb-4" />
        <h2 className="text-2xl font-semibold text-[#041122]">
          Your cart is empty
        </h2>
        <p className="text-gray-500 mt-2">
          Browse our products and add items you like.
        </p>
        <Link
          to="/products"
          className="mt-6 bg-[#B3129E] text-white px-6 py-3 rounded-md hover:bg-[#8f0f7e] transition"
        >
          Start Shopping
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-[#041122] mb-8">Your Cart</h1>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Cart items list */}
        <div className="flex-1 space-y-4">
          {cartItems.map((item) => (
            <div
              key={item.productId}
              className="flex flex-col sm:flex-row items-start sm:items-center gap-4 p-4 border border-gray-200 rounded-lg shadow-sm"
            >
              <img
                src={
                  item.product?.coverImage ||
                  item.product?.images?.[0] ||
                  "/placeholder.png"
                }
                alt={item.product?.name}
                className="w-20 h-20 object-cover rounded-md"
              />
              <div className="flex-1">
                <p className="font-semibold text-[#041122]">
                  {item.product?.name}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() =>
                    updateQuantity(item.productId, item.quantity - 1)
                  }
                  className="p-1 border rounded hover:bg-gray-100"
                >
                  <Minus size={16} />
                </button>
                <span className="w-8 text-center">{item.quantity}</span>
                <button
                  onClick={() =>
                    updateQuantity(item.productId, item.quantity + 1)
                  }
                  className="p-1 border rounded hover:bg-gray-100"
                >
                  <Plus size={16} />
                </button>
                <button
                  onClick={() => removeFromCart(item.productId)}
                  className="p-1 text-red-500 hover:bg-red-50 rounded"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          ))}

          <button
            onClick={clearCart}
            className="text-red-500 text-sm hover:underline"
          >
            Clear Cart
          </button>
        </div>

        {/* Summary */}
        <div className="lg:w-80 bg-gray-50 p-6 rounded-lg h-fit">
          <h2 className="text-xl font-semibold text-[#041122] mb-4">
            Order Summary
          </h2>
          <div className="flex justify-between py-2">
            <span>Items ({getTotalItems()})</span>
          </div>

          <button
            onClick={() => setShowCheckout(true)}
            className="w-full mt-6 bg-[#B3129E] text-white py-3 rounded-md hover:bg-[#8f0f7e] transition"
          >
            Proceed to Checkout
          </button>
        </div>
      </div>

      {/* Checkout Modal */}
      {showCheckout && (
        <ProductInquiryModal
          cartItems={cartItems.map((item) => ({
            productId: item.productId,
            quantity: item.quantity,
            productName: item.product.name,
          }))}
          onClose={() => setShowCheckout(false)}
          onSuccess={() => {
            clearCart();
            setShowCheckout(false);
          }}
        />
      )}
    </div>
  );
};

export default Cart;
